import React, { useEffect, useRef, useState } from 'react';


import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Toast } from 'primereact/toast';

///****************************************Componentes Generales*************************************************** */
import AgGrid from '../../../Components/Tables/AgGrid/AgGrid';
import Loader from '../../../Components/Loader/Loader';
import { getAllPurchaseOrder, getBalancePurchaseDetails } from '../../../API/PurchaseOrders/PurchaseOrderRequest';
import { toastShow } from '../../../Services/ToastService';




const AllPurchaseOrderOverlayPanel = ({ onChange, close,habilitasPO }) => {
    const toast = useRef(null)
    const op = useRef(null)
    const buttom = useRef(false)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [selected, setSelected] = useState([])

    const obtenerPOs = async () => {
        setLoading(true)
        const tempoPO = await getAllPurchaseOrder()
        setData(tempoPO)
        setLoading(false)
    }

    const openOver = (e) => {
        op.current.toggle(e)
        setLoading(true)
        obtenerPOs()
    }

    const table = {
        Data: data,
        Columns: [
            {
                field: 'OrderDate',
                header: 'OrderDate',
                headerEn: 'OrderDate',
                className: 'small',
                Format:'Date'
            },
            {
                field: 'PurchaseOrder',
                header: 'PurchaseOrder',
                headerEn: 'PurchaseOrder',
                className: 'small',
                // onCellDoubleClicked: ({ data }) => {
                //     if (data.PurchaseOrder) {
                //         window.open(`${process.env.REACT_APP_ENV}/OrdenesCompra/${data.PurchaseOrder}`, data.PurchaseOrder, 'height=800,width=1450')
                //     }
                // },
                sort: 'desc',
                Sumary:'count'
            },
            {
                field: 'Vendor',
                header: 'Vendor',
                headerEn: 'Vendor',
                className: 'XXlarge',
            },

            {
                field: 'Currency',
                header: 'Currency',
                headerEn: 'Currency',
                className: 'small',
            },
            {
                field: 'Discount',
                header: 'Discount',
                headerEn: 'Discount',
                className: 'Xsmall',
            },
            {
                field: 'SubTotal',
                header: 'SubTotal',
                headerEn: 'SubTotal',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum'
            },
            {
                field: 'Total',
                header: 'Total',
                headerEn: 'Total',
                className: 'small',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum'
            },

        ],
        onCellClicked: e => AsignarInformacion(e)
    }

    const AsignarInformacion = async (e) => {
        let IdPO = e?.data?.IdPurchaseOrder
        if (IdPO > 0) {
            const tempoDetalles = await getBalancePurchaseDetails(IdPO)
            if (tempoDetalles?.length > 0) {
                onChange(e, tempoDetalles, op)
            }else{
                toastShow(toast, 'error', ' No existen productos con balance de la orden seleccionada' )
            }
        }


    }

    // useEffect(() => {
    //     buttom.current = true
    //     obtenerPOs()
    // }, [buttom.current])
    return (
        <div>
            <div className="p-inputgroup" style={{ width: 200 }}>
                <Toast ref={toast}/>
                {/* <Button label='Agregar Ordenes' onClick={() => AsignarInformacion()} disabled={selected.length === 0 ? true : false} style={{ height: 35 }} /> */}
                <Button icon='pi pi-angle-down' type="button" onClick={(e) => openOver(e)} disabled={habilitasPO} />
            </div>
            <OverlayPanel ref={op} showCloseIcon dismissable={false} style={{ width: '70vw', minHeight: '10vh' }} onHide={close}>
                <div style={{ height: '35vh' }} id='OrdenesCliente'>
                    <Loader loading={loading} querySelector='OrdenesCliente' />
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>
        </div>
    )
}

export default AllPurchaseOrderOverlayPanel